import { inject, Injectable } from "@angular/core";
import { Auth, getIdTokenResult, IdTokenResult, User } from "@angular/fire/auth";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";


@Injectable()
export class AppState {

    private auth = inject(Auth)

    token: string = ''

    userState: Observable<User | any>
    private _userState: BehaviorSubject<User | any>
    
    constructor(private router: Router) {

        this._userState = new BehaviorSubject(null)
        this.userState = this._userState.asObservable()

        this.refreshToken(true).then()

        this.auth.authStateReady().then(() => {
            // this.initialized.next(true);
        })

        this.auth.onAuthStateChanged((user: User | null) => {
            this.reloadUser(user)
        })

        this.auth.onIdTokenChanged((user: User | null) => {
            this.reloadUser(user)
        })

    }

    async refreshToken(forceRefresh: boolean = false): Promise<any> {
        return this.user?.getIdTokenResult(forceRefresh).then((tokenResult: any) => {
            this.token = tokenResult.token
            let newRoles: string[] = (tokenResult.claims['roles'] as string[]) ?? []
        })
    }

    get user(): User | any {
        return this._userState.getValue()
    }

    set user(value: User | any) {
        this._userState.next(value)
    }


    private reloadUser(user: User | null) {
        // if (this._isLoading) {
        //     return
        // }

        // this._isLoading = true
        this.user = user

        if (this.user !== null) {
            getIdTokenResult(this.user).then((tokenResult: IdTokenResult) => {
            this.token = tokenResult.token
            let newRoles: string[] = (tokenResult.claims['roles'] as string[]) ?? []
            // this.roles.next(newRoles)
            // this.rolesLoaded.next(true)
            this.checkForActiveSessionAndRedirect()
            })
        } else {
            this.cleanUp()
        }
    }

    private checkForActiveSessionAndRedirect(): void {
        // if (this.router.url !== '/' || this.router.url.startsWith('/get-started')) {
        //     return
        // }
        // if (window.location.pathname.startsWith('/admin')) {
        //     return
        // }

        // // Always redirect authenticated users to dashboard
        // this.router.navigate(['/dashboard'])
    }

    logout(): void {
        this.auth.signOut().then(() => {
            this.cleanUp()
        })
    }

    cleanUp(): void {

    }

}
